import React, {useEffect} from "react";
import "./App.css";

import { GithubButton, EmailButton, LinkedInButton } from "./Components/IconButton";
import selfPhoto from "./assets/mept3.jpeg"

export default function App() {
  
  useEffect(() => {
    document.title = "𝐻𝑜𝓂𝑒";
  }, [])
  
  return (
      <div className="app-container">
        <header className="header">
          <div className="profile-header">
            <div>
              <img className="selfPhoto" src={selfPhoto} alt="self-photo"/>
              <h1 className="name">Ruben Thomas</h1>
              <p className="tagline">Aspiring Software Engineer • CIS Student • Tech Lover</p>
            </div>
          </div>
        </header>

        <main className="main-content">
          {/* About Section */}
          <section className="section">
            <h2 className="section-title">About Me</h2>
            <p className="section-text">
              I'm a passionate university student with a strong interest in the field of software engineering.
              Hoping to further my understanding of tech and fulfill my long-term dream and ambition of becoming a software engineer.
            </p>
          </section>

          {/* Projects Section */}
          <section className="section">
            <h2 className="section-title">Projects</h2>
            <ul className="project-list">
              <li className="project-item">
                <h3 className="project-title">Task Manager App (CIS445)</h3>
                <p className="project-description">Collaborative React app made to create, edit, and manage daily tasks with chart visualizations.</p>
                <a href="https://github.com/StrangeEcho/BAT-Task-Manager" className="project-link">View Code</a>
              </li>
              <li className="project-item">
                <h3 className="project-title">Banker System (CIS317)</h3>
                <p className="project-description">A terminal-based application made to emulate a banker-like experience while exhibiting CRUD operations.</p>
                <a href="https://github.com/StrangeEcho/CIS317-Final-Project" className="project-link">View Code</a>
              </li>
              <li className="project-item">
                <h3 className="project-title">Simple Tip Calculator & Tracker (CIS340)</h3>
                <p className="project-description">Seamless and easy to use Android tip tracking and calculator app for servers in the service industry.</p>
                <a href="https://github.com/StrangeEcho/SimpleTipCalculator/" className="project-link">View Code</a>
              </li>
            </ul>
          </section>

          {/* Skills Section */}
          <section className="section">
            <h2 className="section-title">Skills & Technologies</h2>
            <ul className="skills-list">
              <li>Languages: Python (strongest), C#, JavaScript</li>
              <li>Frameworks: React</li>
              <li>Tools: VSCode, WebStorm, PyCharm, Rider, Gitlab, Github, Git, SQL, SQLite</li>
            </ul>
          </section>

          {/* Contact Section */}
          <section className="section">
            <h2 className="section-title">Links & More</h2>
            <EmailButton />
            <GithubButton />
            <LinkedInButton />
          </section>

          <section className="section">
            <a href="https://docs.google.com/document/d/1h-ii2aNnmMN0FFI5lt00Gw3GiWmNrLwE/preview">Click Here For Resume</a>
          </section>
        </main>
      </div>
  );
}
